var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAddTrigger = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico_new_trigger",
    transform: "translate(20058 22009)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18769",
    "data-name": "Rectangle 18769",
    width: 20,
    height: 20,
    transform: "translate(-20058 -22009)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_27",
    "data-name": "Polygon 27",
    d: "M6.3,2.768a2,2,0,0,1,3.407,0l4.421,7.184A2,2,0,0,1,12.421,13H3.579a2,2,0,0,1-1.7-3.048Z",
    transform: "rotate(90 983.5 -21023.5)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAddTrigger);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_add_trigger.f5e60b12d28f3032494ca65626d99f7d.svg";